var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"fixed-bottom section footer"},[_vm._v(" Made by "),_c('a',{attrs:{"href":"https://rightclick.com.au/"}},[_vm._v("rightclick.com.au")])])
}]

export { render, staticRenderFns }